export default "__VITE_ASSET__66e14265__"